import { render } from "./ErrorContent.vue?vue&type=template&id=533a1bb7&scoped=true"
import script from "./ErrorContent.vue?vue&type=script&lang=js"
export * from "./ErrorContent.vue?vue&type=script&lang=js"

import "./ErrorContent.vue?vue&type=style&index=0&id=533a1bb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533a1bb7"]])

export default __exports__